
export function detectIconClassByMimeType(mimeType) {
    let iconClass = 'fa-file'

    switch (mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
            iconClass = 'fa-file-image'
            break
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            iconClass = 'fa-file-excel'
            break
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
            iconClass = 'fa-file-word'
            break
        case 'application/zip':
            iconClass = 'fa-file-archive'
            break;
        case 'application/pdf':
            iconClass = 'fa-file-pdf'
            break
    }

    return iconClass
}